import { storageKeys } from '@constants';
import { getStorageData, removeStorageItem, setStorageData } from '@utils/storage';

const { USER_ACCESS_TOKEN, USER_REFRESH_TOKEN, USER_EMAIL, X_TENANT, IS_ADMIN } = storageKeys;

export const getCacheAccessToken = () => getStorageData(USER_ACCESS_TOKEN);

export const getCacheRefreshToken = () => getStorageData(USER_REFRESH_TOKEN);

export const setCacheAccessToken = (accessToken) => setStorageData(USER_ACCESS_TOKEN, accessToken);

export const setCacheRefreshToken = (refreshToken) => setStorageData(USER_REFRESH_TOKEN, refreshToken);

export const setCacheToken = (accessToken, refreshToken) => {
    setCacheAccessToken(accessToken);
    setCacheRefreshToken(refreshToken);
};
export const getCacheX_tenant = () => getStorageData(X_TENANT);
export const setCacheX_tenant = (data) => setStorageData(X_TENANT, data);
export const removeCacheX_tenant = () => removeStorageItem(X_TENANT);
export const removeCacheAccessToken = () => removeStorageItem(USER_ACCESS_TOKEN);

export const getCacheIsAdmin = () => getStorageData(IS_ADMIN);
export const setCacheIsAdmin = (data) => setStorageData(IS_ADMIN, data);
export const removeCacheIsAdmin = () => removeStorageItem(IS_ADMIN);

export const removeCacheRefreshToken = () => removeStorageItem(USER_REFRESH_TOKEN);

export const removeCacheToken = () => {
    removeCacheAccessToken();
    removeCacheRefreshToken();
    removeCacheIsAdmin();
    removeCacheX_tenant();
};


export const setCacheUserEmail = (email) => setStorageData(USER_EMAIL, email);

export const getCacheUserEmail = () => getStorageData(USER_EMAIL);
